import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

function Footer() {
    return (
        <footer className="footer">
            <div className="footer_copyright">
                <p>&copy; 2026 Goncalo Ferraz</p>
            </div>
        </footer>
    );
}

export default Footer;
